module.exports = __webpack_public_path__ + "img/top_bg.a03a844f.png";